import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './HeaderPagesMobile.module.css';

function HeaderPagesMobile({ icon, namePage, showBackButton = true }) {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <header className={styles.headerMobile}>
      {showBackButton && (
        <button onClick={handleBack} className={styles.backButton}>
          <FaArrowLeft />
        </button>
      )}
      <div className={styles.headerContent}>
        {icon && (
          <div className={styles.iconContainerMobile}>
            {icon}
          </div>
        )}
        <h1 className={styles.titleMobile}>{namePage}</h1>
      </div>
    </header>
  );
}

export default HeaderPagesMobile;
